import React from 'react';
import styles from '../styles/comp1test.module.css';

const RouteChefAd = () => {
  return (
    <div className={styles['routechef-container']}>
      <div className={styles['text-section']}>
        <h1 className={styles.heading}>Get Routechef App</h1>
        <p className={styles.subheading}>
          Take control of your trips with our AI-powered app. Travel without
          hassle and get route options with trains and flights
        </p>
        <button className={styles['download-button']}
        onClick={() => window.open("https://play.google.com/store/apps/details?id=indianrailapp.railapp.routechef.myrailapp&hl=en_US&gl=IN", "_blank")}
        >Download App</button>
      </div>

      <div className={styles['image-section']}>
        <img className={styles.comp1_imgstyle} src="/mob1.png" alt="Phone" />
      </div>
    </div>
  );
};

export default RouteChefAd;
